import { Add, HowToReg, Email, Folder, Height, Person, PersonOff, Workspaces } from "@mui/icons-material";
import { Box, Button, Grid, Paper, SvgIcon, TableCell, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { BackButton } from "../../../../../components/Button/BackButton/BackButton";
import { KeyDriveBodyMin } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDriveh4Header } from "../../../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { KeyDriveTabPanel } from "../../../../../components/KeydriveComponents/Tabs/components/KeyDriveTabPanel";
import { KeyDriveTab } from "../../../../../components/KeydriveComponents/Tabs/KeyDriveTab";
import { WorkSpaceUserName } from "../../../../../model/ItemModel";
import { WorkSpaceUpdate } from "../../../../../model/WorkSpaceModel";
import { GetWorkSpaceItemTrim } from "../../../../../services/Item/ItemServicesGet";
import { GetOneWorkSpace } from "../../../../../services/WorkSpaceServices";
import { AdminWorkspaceWrapper } from "../AdminWorkspaceWrapper/AdminWorkspaceWrapper";
import { DocumentsList } from "./DocumentsList/DocumentsList";
import {WorkspaceUserConfig} from "../WorkspaceUserConfig/WorkspaceUserConfig";
import { PrivilegesTableUser } from "../../../UsersAndGroups/components/PrivilegesTable/PrivilegesTableUser";
import { KeyDriveTab2 } from "../../../../../components/KeydriveComponents/Tabs/KeydriveTab2";


export const WorkspaceDetails = () => {
    const { nameOrg, idWorkspace } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [workspace, setWorkspace] = useState<WorkSpaceUpdate>({} as WorkSpaceUpdate);
    const [value, setValue] = useState(0);
    const [items, setItems] = useState<WorkSpaceUserName[]>([]);
    
    useEffect(() => {
        if (idWorkspace != undefined) {
            GetOneWorkSpace(idWorkspace)
                .then(data => {
                    if (data != null) {
                        console.log(data)
                        setWorkspace(data);
                    }
                })
                .catch()
                .finally();
        }
    }, []);

    useEffect(() => {
        if (idWorkspace != undefined) {
            GetWorkSpaceItemTrim(idWorkspace, 0, 10, false)
                .then(data => {
                    setItems(data)
                })
                .catch()
                .finally()
        }
    }, [idWorkspace])

    return (
        <AdminWorkspaceWrapper>
            <Box
                display="flex"
                flexDirection="column"
            >
                <Box
                    mb="14.5px"
                >
                    <BackButton
                        backurl={`/${nameOrg}/adminConsole/workspaces`}
                    />
                </Box>
                <Box sx={{
                    display: 'flex',
                    flexDirection: "row",
                    gap: '12px',
                }}>
                    <Workspaces sx={{
                        color: "#22638D",
                        alignSelf: 'self-end',
                        width: '27px',
                        height: '27px',
                    }} widths='24px' height='24px' />
                    <KeyDriveh4Header
                        color="#2D2D2D"
                        needEllipses={false}
                        text={workspace.name!}
                        needBold
                    />
                </Box>
                <Box
                    mt="10px"
                    mb="28px"
                >
                    <KeyDriveBodyMin
                        color="#969696"
                        needEllipses={false}
                        text={workspace.description != undefined ? workspace.description : t("AdminConsole.NoDescription")}
                        needBold={false}
                    />
                </Box>
            </Box>
            <KeyDriveTab2
                icon1={<Folder />}
                icon2={<Person />}
                label1={t("AdminConsole.Documents")}
                label2={t("AdminConsole.UsersWithAccess")}
                onChange={(ev, i) => { setValue(i) }}
            >
                <KeyDriveTabPanel
                    index={0}
                    value={value}
                >
                    <DocumentsList items={items} />
                </KeyDriveTabPanel>
                <KeyDriveTabPanel
                    index={1}
                    value={value}
                >
                    <WorkspaceUserConfig viewOnly hasPrivilegesColumn/>
                </KeyDriveTabPanel>
            </KeyDriveTab2>
        </AdminWorkspaceWrapper >
    )
}